import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";
import logoEntrelaces from "@/assets/logo-entrelaces.png";
import { Button } from "./ui/button";
import { useWarningPopup } from "@/contexts/WarningPopupContext";

const Footer = () => {
  const warningPopup = useWarningPopup();
  return (
    <>
      <footer className="bg-sage-dark text-primary-foreground py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img 
                src={logoEntrelaces} 
                alt="Entrelaces Psicologia" 
                className="h-12 w-auto brightness-0 invert"
                width={57}
                height={48}
                sizes="48px"
                loading="lazy"
              />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Aqui, sua história encontra escuta. Psicoterapia com acolhimento e
              profissionalismo em Recife.
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg font-semibold">Contato</h3>
            <div className="space-y-3">
              <a
                href="https://wa.me/5581984555155"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <Phone className="w-4 h-4" />
                (81) 98455-5155
              </a>
              <a
                href="mailto:contato@entrelaces.com.br"
                className="flex items-center gap-3 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <Mail className="w-4 h-4" />
                contato@entrelaces.com.br
              </a>
            </div>
          </div>

          {/* Address */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg font-semibold">Endereço</h3>
            <div className="flex items-start gap-3 text-sm text-primary-foreground/80">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <span>
                Empresarial Alcides Fernandes
                <br />
                Praça de Casa Forte, 381 - Sala 503
                <br />
                Casa Forte, Recife - PE
                <br />
                52061-420
              </span>
            </div>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Praça+de+Casa+Forte,+381+-+Sala+503+-+Recife+PE"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary-foreground/10 hover:bg-primary-foreground/20 text-primary-foreground text-sm font-medium rounded-full transition-colors duration-300"
            >
              <MapPin className="w-4 h-4" />
              Ver no mapa
            </a>
          </div>

          {/* Social */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg font-semibold">Redes Sociais</h3>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/entrelacespsicologia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram da Entrelaces Psicologia"
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com/entrelaces"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook da Entrelaces Psicologia"
                className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
            <div className="mt-6">
              <Button variant="hero" size="lg" onClick={warningPopup.open}>
                Agendar pelo WhatsApp
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-primary-foreground/80">
              © {new Date().getFullYear()} Entrelaces Psicologia. Todos os direitos reservados.
            </p>
            <div className="flex gap-6">
              <Link
                to="/privacidade"
                className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                Política de Privacidade
              </Link>
              <Link
                to="/termos"
                className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                Termos de Uso
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
